// extracted by mini-css-extract-plugin
export default {"header":"cgh6WFb_h","innerHeader":"clGih1Jmh","h2adv":"cFOGrvkDA"};